<div class="messageList" *ngIf="messages">
    <div class="messageList-item" *ngFor="let message of messages; index as i" [class._active]="selectedIndex == i">
        <kiwi-message-card [message]="message"
                           [displayUnreadStatus]="displayUnreadStatus"
                           (click)="onSelect(i)"></kiwi-message-card>
    </div>
</div>
